import "@hotwired/turbo-rails";
import "./controllers";
import Rails from "@rails/ujs";
import "chartkick";
import "chartkick/chart.js";
import "trix";
import "@rails/actiontext";
import * as ActiveStorage from "@rails/activestorage";

ActiveStorage.start();

document.addEventListener("change", (event) => {
  const input = event.target.closest('input[type="file"][data-max-file-size]');
  if (!input) return;

  const files = Array.from(input.files || []);
  const maxFileSize = Number(input.dataset.maxFileSize);
  const maxFiles = Number(input.dataset.maxFiles || 1);
  const maxTotalSize = Number(input.dataset.maxTotalSize || maxFileSize);
  const oversizedFile = files.find((file) => file.size > maxFileSize);
  const totalSize = files.reduce((total, file) => total + file.size, 0);

  let error;
  if (files.length > maxFiles) {
    error = `Select no more than ${maxFiles} file${maxFiles === 1 ? "" : "s"}.`;
  } else if (oversizedFile) {
    error = `${oversizedFile.name} exceeds the ${Math.round(maxFileSize / 1024 / 1024)} MB limit.`;
  } else if (totalSize > maxTotalSize) {
    error = `The selected files exceed the ${Math.round(maxTotalSize / 1024 / 1024)} MB total limit.`;
  }

  if (error) {
    input.value = "";
    window.alert(error);
  }
});

// Initialize Rails UJS
Rails.start();
Turbo.session.drive = true;

// Configure Turbo
Turbo.config.drive.progressBarDelay = 0;
document.documentElement.setAttribute("data-turbo-prefetch", "false");

// Turbo Drive event listeners for spinner
document.addEventListener("turbo:load", () => {
  const spinner = document.querySelector("[data-turbo-loading]");
  if (spinner) {
    spinner.classList.add("hidden");
  }
});

document.addEventListener("turbo:before-fetch-request", (event) => {
  // Only show spinner for navigation, not prefetch
  if (event.detail.fetchOptions.headers["Turbo-Frame"]) return;

  const spinner = document.querySelector("[data-turbo-loading]");
  if (spinner) {
    spinner.classList.remove("hidden");
  }
});

document.addEventListener("turbo:before-fetch-response", () => {
  const spinner = document.querySelector("[data-turbo-loading]");
  if (spinner) {
    spinner.classList.add("hidden");
  }
});
